/**
 * Helper central para escribir en la bitácora de auditoría (append-only) del
 * backend activo. Fire-and-forget: la auditoría NUNCA bloquea ni rompe la
 * acción de negocio (si falla, se registra en consola y se sigue).
 *
 * Lo usan tanto las acciones admin (reset, backup, claves) como los puntos de
 * negocio sensibles (aprobaciones, firmas, cambios de estado).
 */

import { buildRepos } from "../data/repos";
import type { NuevaAuditEntry } from "../data/repos/AuditLogRepo";

export interface DatosAuditoria {
  /** Email del usuario que ejecuta la acción. */
  usuario: string;
  /** Código corto de la acción (ej. "SO_APROBADA", "RESET_TOTAL"). */
  accion: string;
  /** Tipo de entidad afectada (ej. "SO", "AFE", "Sistema"). */
  entidad: string;
  /** Id/código de la entidad afectada. */
  entidadId: string;
  /** Momento del evento (ISO). Por defecto, ahora. */
  timestamp?: string;
  /** Detalle estructurado opcional (estado anterior/nuevo, montos, motivo…). */
  diff?: Record<string, unknown>;
}

export async function registrarAuditoria(
  tenantId: string,
  datos: DatosAuditoria,
): Promise<void> {
  const data: NuevaAuditEntry = {
    timestamp: datos.timestamp ?? new Date().toISOString(),
    usuario: datos.usuario,
    accion: datos.accion,
    entidad: datos.entidad,
    entidadId: datos.entidadId,
    ...(datos.diff ? { diff: datos.diff } : {}),
  };
  try {
    await buildRepos(tenantId).auditLog.create(data);
  } catch (e) {
    console.error("[auditoria] no se pudo registrar la entrada:", e);
  }
}
